import { List, Record } from 'immutable'
import { Company, ICompany } from './Company'

export interface ICompanyResult {
  resultCount: number
  results: List<ICompany>
  timestamp: number
}

const CompanyResultRecord = Record({
  count: 0,
  results: List<Company>(),
  timestamp: Math.round(new Date().getTime() / 1000),
})

export class CompanyResult extends CompanyResultRecord {
  public static fromJS(initialState?: Partial<ICompanyResult>) {
    if (!initialState) {
      return new CompanyResult()
    }

    const { resultCount, results, timestamp, ...rest } = initialState
    return new CompanyResult({
      ...rest,
    })
  }

  public readonly resultCount: number
  public readonly results: List<Company>

  constructor(initialState?: Partial<CompanyResult>) {
    initialState ? super(initialState) : super()
  }
}
